import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const selectedNetworkAtom = atom({
	key: "selectedNetworkAtom",
	default: null,
	effects_UNSTABLE: [persistAtom],
});
